import React from "react";
import "@fortawesome/fontawesome-svg-core/styles.css";
import styled from "styled-components";
import Cta from "../../atoms/CTA-Contrast/index";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons/faArrowRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF } from "@fortawesome/free-brands-svg-icons/faFacebookF";
import { faXTwitter } from "@fortawesome/free-brands-svg-icons/faXTwitter";
import { faYoutube } from "@fortawesome/free-brands-svg-icons/faYoutube";
import { faInstagram } from "@fortawesome/free-brands-svg-icons/faInstagram";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons/faLinkedinIn";
import colors from "../../../helpers/colors";
import globalText from "../../../helpers/globalText";
import PeopleFooter from "../../../resources/images/footer/footer-people.png";
import MVLogo from "../../../resources/images/logo-wordmark-white.png";

const Footer = styled.div`
  background: ${colors.mvBlue};
  width: 100%;
  height: 1100px;

  @media (max-width: 769px) {
    height: 1460px;
  }
  @media (max-width: 600px) {
    height: 1700px;
  }
`;

const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding-top: 41px;
`;

const CtaBanner = styled.div`
  width: 90%;
  margin: 0 auto;
  background-image: url(${PeopleFooter});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 350px;
  padding-top: 110px;
  display: flex;
  align-items: center;
  flex-direction: column;

  .footer__arrow-right {
    font-size: 48px;
    margin-left: 19px;
  }

  @media (max-width: 1400px) {
    width: 100%;
    height: 370px;
  }
  @media (max-width: 900px) {
    height: 280px;
  }
  @media (max-width: 1400px) {
    height: 340px;
  }
`;

const CtaPreText = styled.h6`
  color: ${colors.mvWhite};
  font-size: 28px;
  text-align: center;
`;

const CtaText = styled.h5`
  font-size: 80px;
  text-align: center;
  color: ${colors.mvWhite};
  margin: 16px auto;
  font-weight: 900;

  @media (max-width: 769px) {
    font-size: 30px;
    margin-bottom: 50px;
  }
`;

const LinkContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 1200px;
  margin: 150px auto 130px auto;

  @media (max-width: 1250px) {
    width: auto;
  }

  @media (max-width: 769px) {
    flex-wrap: wrap;
    justify-content: start;
    margin-top: 0;
  }

  @media (max-width: 600px) {
    justify-content: start;
  }
`;

const LinkColumn = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 1250px) {
    padding: 0 20px;
  }

  @media (max-width: 769px) {
    width: 30%;
    margin: 30px 10px;
  }
`;

const LinkColumnTitle = styled.h6`
  color: ${colors.mvWhite};
  font-size: 20px;
  margin-bottom: 20px;
`;

const LinkItem = styled.a`
  color: ${colors.mvWhite};
  font-size: 16px;
  margin: 5px 0;
  text-decoration: none;
  transition: 0.3s;

  &:hover {
    color: ${colors.mvVividOrange};
    cursor: pointer;
    transition: 0.3s;
  }
`;

const LogoSectionContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;

  @media (max-width: 1250px) {
    padding: 0 20px;
  }
  @media (max-width: 769px) {
    flex-direction: column;
    align-items: center;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const Tagline = styled.p`
  color: ${colors.mvWhite};
  line-height: 26px;
  font-size: 16px;
  max-width: 300px;
  margin-top: 18px;

  @media (max-width: 769px) {
    text-align: center;
    margin-bottom: 30px;
  }
`;

const InfoTextLink = styled.a`
  color: ${colors.mvWhite};
  text-align: right;
  font-weight: 300;
  margin: 3px 0;
  font-size: 16px;
  text-decoration: none;

  @media (max-width: 769px) {
    text-align: center;
  }
`;

const InfoText = styled.p`
  color: ${colors.mvWhite};
  text-align: right;
  font-weight: 300;
  margin: 3px 0;
  font-size: 16px;

  @media (max-width: 769px) {
    text-align: center;
  }
`;

const SocialLinkRow = styled.div`
  display: flex;
  justify-content: end;
  margin-top: 20px;

  @media (max-width: 769px) {
    justify-content: center;
  }
`;

const SocialIcon = styled.a`
  text-decoration: none;
  color: ${colors.mvWhite};
  font-size: 18px;
  margin-right: 12px;

  &:last-child {
    margin-right: 0;
  }
`;

const PageFooter = ({ footerNavigation, hideTop }) => {
  const createLinkElement = (link) => {
    if (link.href) {
      return <LinkItem to={link.href}>{link.label}</LinkItem>;
    }
    return <LinkItem href={link.externalHref}>{link.label}</LinkItem>;
  };

  const socialLinks = [
    {
      url: "https://www.facebook.com/motivosity",
      icon: faFacebookF,
      alt: "Follow Motivosity on Facebook",
    },
    {
      url: "https://twitter.com/motivosity",
      icon: faXTwitter,
      alt: "Follow Motivosity on Twitter",
    },
    {
      url: "https://www.youtube.com/user/motivosity",
      icon: faYoutube,
      alt: "Follow Motivosity on Youtube",
    },
    {
      url: "https://www.instagram.com/motivosity/",
      icon: faInstagram,
      alt: "Follow Motivosity on Instagram",
    },
    {
      url: "https://www.linkedin.com/company/motivosity",
      icon: faLinkedinIn,
      alt: "Follow Motivosity on LinkedIn",
    },
  ];

  return (
    <Footer
      style={{
        height: !hideTop ? (typeof window !== "undefined" && window.innerWidth > 900 ? "1100px" : "auto") : "auto",
        paddingBottom: '50px',
        paddingTop: !hideTop ? '0px' : '50px'

      }}
    >
      <Container>
        {!hideTop && (
          <CtaBanner>
            <CtaPreText>What are you waiting for?</CtaPreText>
            <CtaText>Get a custom demo</CtaText>
            <Cta ctaText={globalText.watchADemo} ctaHref="/demo/" />
          </CtaBanner>
        )}

        <LinkContainer style={{marginTop : !hideTop ? '' : '-25px'}}>
          {footerNavigation.map((column, index) => {
            return (
              <LinkColumn key={column.title + index}>
                <LinkColumnTitle>{column.title}</LinkColumnTitle>
                {column.links.map((link, index) => {
                  return (
                    <LinkItem key={link.label + index}>
                      {createLinkElement(link)}
                    </LinkItem>
                  );
                })}
              </LinkColumn>
            );
          })}
        </LinkContainer>

        <LogoSectionContainer>
          <Column>
            <img
              src={MVLogo}
              alt="Motivosity Logo"
              style={{ width: "284px" }}
            />
            <Tagline>
              The people-first Recognition and Rewards solution for today's
              workforce.
            </Tagline>
          </Column>

          <Column>
            <InfoTextLink href="tel:8017587188">801.758.7188</InfoTextLink>
            <InfoTextLink href="mailto:sales@motivosity.com">
              sales@motivosity.com
            </InfoTextLink>
            <InfoText>
              ThanksMatters Visa® Commercial Credit cards are powered by Stripe
              and issued by Celtic Bank.
            </InfoText>
            <InfoText>Copyright © 2012 - 2025 Motivosity Inc.</InfoText>
            <SocialLinkRow>
              {socialLinks.map(({ url, icon, alt }) => (
                <SocialIcon href={url} key={url} target="_blank" rel="noopener">
                  <FontAwesomeIcon icon={icon} alt={alt} />
                </SocialIcon>
              ))}
            </SocialLinkRow>
          </Column>
        </LogoSectionContainer>
      </Container>
    </Footer>
  );
};

PageFooter.defaultProps = {
  footerNavigation: [
    {
      title: "Platform",
      links: [
        {
          label: "Recognition",
          externalHref: "/platform/employee-recognition/",
        },
        {
          label: "Rewards",
          externalHref: "/platform/employee-rewards/",
        },
        {
          label: "Programs",
          externalHref: "/platform/employee-programs/",
        },
        {
          label: "Connection",
          externalHref: "/platform/company-culture/",
        },
        {
          label: "Communication",
          externalHref: "/platform/employee-communication/",
        },
        {
          label: "Surveys",
          externalHref: "/platform/employee-engagement/",
        },
      ],
    },
    {
      title: "Resources",
      links: [
        {
          label: "Resource Library",
          externalHref: "/resources/",
        },
        {
          label: "Videos",
          externalHref: "/resources/#videos",
        },
        {
          label: "White Papers",
          externalHref: "/resources/#whitepapers",
        },
        {
          label: "Case Studies",
          externalHref: "/resources/#culturestudies",
        },
        {
          label: "Webinars",
          externalHref: "/resources/#webinars",
        },
      ],
    },
    {
      title: "Company",
      links: [
        {
          label: "About Us",
          externalHref: "/about-us/",
        },
        {
          label: "Referral Program",
          externalHref: "/referral/",
        },
        {
          label: "Pricing",
          externalHref: "/pricing/",
        },
        {
          label: "Careers",
          externalHref: "/careers/",
        },
      ],
    },
    {
      title: "Learn",
      links: [
        {
          label: "What's New",
          externalHref: "/whats-new/",
        },
        {
          label: "Blog",
          externalHref: "/resources/#blogs",
        },
        {
          label: "Press Releases",
          externalHref: "/resources/#pressreleases",
        },
        {
          label: "Carl's Story",
          externalHref: "/carl/",
        },
      ],
    },
    {
      title: "Support",
      links: [
        {
          label: "Product Help",
          externalHref: "https://help.motivosity.com/",
        },
        {
          label: "Privacy",
          externalHref: "/legal/privacy/",
        },
        {
          label: "Security",
          externalHref: "/legal/security/",
        },
        {
          label: "Integrations",
          externalHref: "/integrations/",
        },
      ],
    },
  ],
};

PageFooter.propTypes = {};

export default PageFooter;
